<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.AddCashFlowItem')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="340px"
  >
    <el-form v-model="form" label-width="120px">
      <el-form-item>
        <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PleaseSelectVoucherGroupingRule') }}</span>
        <el-select
          v-model="form.accountingDocumentRuleUuid"
          style="width: 200px;"
          @change="checkAvailableEntryTypes"
        >
          <el-option
            v-for="(item, index) in accountingDocumentRules"
            :key="index"
            :value="item.uuid"
            :label="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PSGROJE') }}</span>
        <el-select v-model="form.entryRuleUuid" style="width: 200px;">
          <el-option
            v-for="(item, index) in entryRules"
            :key="index"
            :value="item.uuid"
            :label="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_AccountTitleCodeP') }}</span>
        <el-input v-model="form.accountTitle" style="width: 200px;" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_DebitSideCreditSideP')">
        <el-select v-model="form.codeMappingType" style="width: 200px;">
          <el-option :value="0" :label="this.$t('CargoMsg.Cargo_DebitSide')" />
          <el-option :value="1" :label="this.$t('CargoMsg.Cargo_CreditSide')" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveHandler">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as accountingEntryRuleApi from '@/api/financeManage/accountingEntryRule'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as accountingDocumentsRuleApi from '@/api/financeManage/accountingDocumentsRule'

export default {
  name: 'CashflowItemDialog',
  props: {
    visible: { type: Boolean, require: true },
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      accountingDocumentRules: [],
      entryRules: [],
      entryRuleUuid: '',
      isStep1: true,
      form: {
        accountingDocumentRuleUuid: '',
        entryRuleUuid: '',
        accountTitle: '',
        codeMappingType: 0
      }
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.initForm()
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    this.loadaccountingDocumentRules()
  },
  methods: {
    async loadaccountingDocumentRules() {
      const accountingDocumentRules = this.accountSet.accountingDocumentsRule // await accountingDocumentsRuleApi.query({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.list)
      for (const rule of accountingDocumentRules) {
        rule.name = this.bizTypeDDLLabelFun(rule)
      }
      this.accountingDocumentRules = accountingDocumentRules
    },
    saveHandler() {
      if (!this.form.accountingDocumentRuleUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucherGroupingRule'))
        return
      }
      if (!this.form.entryRuleUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSGROJE'))
        return
      }
      if (!this.form.accountTitle || this.form.accountTitle.trim().length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AccountTitleCodeCanTBeEmpty'))
        return
      }
      const accountingDocumentRule = this.accountingDocumentRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      const entryRule = this.entryRules.find(rule => rule.uuid === this.form.entryRuleUuid)
      if (!accountingDocumentRule || !entryRule) {
        this.$message.info(this.$t('CargoMsg.Cargo_PSGROJE'))
        return
      }
      const object = {}
      object.businessDataType = accountingDocumentRule.businessDataType
      object.entryType = entryRule.entryType
      object.accountTitle = this.form.accountTitle
      object.codeMappingType = String(this.form.codeMappingType)
      object.priority = 0
      object.valueType1 = false
      this.$emit('enter', object)
    },
    async checkAvailableEntryTypes() {
      const rule = this.accountingDocumentRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      if (rule && !rule.accountingEntryRule) {
        const params = {}
        params.accountingDocumentRuleUuid = rule.uuid
        params.accountSetUuid = this.accountSet.uuid
        await accountingEntryRuleApi.query(params).then(resp => {
          rule.accountingEntryRule = resp.data.list
        })
      }
      rule.accountingEntryRule.forEach(rule => { rule.name = this.entryRuleLabelFunc(rule) })
      this.entryRules = rule.accountingEntryRule
      this.form.entryRuleUuid = ''
    },
    bizTypeDDLLabelFun(rule) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, rule.businessDataType)
      let label = state == null ? '' : state.chineseName
      if (label && rule.accountingMode && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        label += '(' + FinanceInterfaceConstants.MODE_HEDGE.chineseName + ')'
      }
      return label
    },
    entryRuleLabelFunc(accountingEntryRule) {
      if (accountingEntryRule) {
        const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, accountingEntryRule.entryType)
        if (state) {
          return state.chineseName
        }
      }
      return ''
    },
    initForm() {
      this.form = {
        accountingDocumentRuleUuid: '',
        entryRuleUuid: '',
        accountTitle: '',
        codeMappingType: 0
      }
    }
  }
}
</script>

<style scoped>

</style>
